// ** Redux Imports
import { createSlice } from '@reduxjs/toolkit'

export const listActionSlice = createSlice({
  name: 'listActions',
  initialState: {
    module: null,
    deleteId: null,
    editId: null,
    verifyId: null,
    notificationId: null
  },
  reducers: {
    handleDelete: (state, action) => {
      state.module = action.payload.module
      state.deleteId = action.payload.deleteId
    },
    handleUnpluggedDelete: state => {
      state.module = null 
      state.deleteId = null
    },
    handleEdit: (state, action) => {
        state.module = action.payload.module
        state.editId = action.payload.editId
    },      
    handleUnpluggedEdit: state => {
      state.module = null
      state.editId = null        
    },    
    handleVerify: (state, action) => {
        state.module = action.payload.module
        state.verifyId = action.payload.verifyId
    },
    handleUnpluggedVerify: state => {
      state.module = null
      state.verifyId = null        
    },
    handleViewNotification: (state, action) => {
      state.module = action.payload.module
      state.notificationId = action.payload.notificationId
    },
    handleUnpluggedViewNotification: state => {
      state.module = null
      state.viewNotificationId = null        
    }
  }
})

export const { handleDelete, handleUnpluggedDelete, handleEdit, handleUnpluggedEdit, handleVerify, handleUnpluggedVerify, handleViewNotification, handleUnpluggedViewNotification } = listActionSlice.actions

export default listActionSlice.reducer
